import React from 'react'
import {Link} from 'react-router-dom';
const EventCard = ({cardInfo,sortM}) => {
    // if(cardInfo.photos.length === 0) { return null; }
    return ( 
        <div className="card m-3" style={{width: '400px'}}>            
        <img
            src={
                cardInfo.photos.length===0 ?
                "https://media-exp1.licdn.com/dms/image/C561BAQEBcFsCTFxXOg/company-background_10000/0/1642413192125?e=2147483647&v=beta&t=9xv9V3Gi1NO6U5zdHicAsKOqpjxkUrGy7sxLKFA2Ogg" :
                cardInfo.photos[0].imageLocation
            }
            className="card-img-top"
            alt="card-img-top"
            style={{
                height: '200px'
            }}
        />
        <div className="card-body">
            <h5 className="card-title">{cardInfo.eventPurpose}</h5>
            <p className="card-text"><small className="text-muted">Presented by Alumni: {cardInfo.alumniName }</small></p>
            <p className="card-text" style={{height:'150px',overflow:'hidden'}}>
                {cardInfo.eventInDetail}
            </p>
            
            <span className="card-text"><small className="text-muted">Conducted By: {cardInfo.conductedBy}</small></span>                        
            <div className="d-flex justify-content-between align-items-center w-100">
                <p className="card-text"><small className="text-muted">On: {
                    cardInfo.eventStartDate===null ?
                    "Not Available" :                    
                    cardInfo.eventStartDate.split("T")[0]
                }</small></p>
                <Link className="btn btn-primary" to={`/event/${cardInfo.id}`}>View More</Link>
            </div>
        </div>
        </div>

     );
}
 
export default EventCard;